/**
 * Format a number as currency (SEK)
 * @param amount Number to format
 * @returns Formatted currency string (e.g. "123.45 kr")
 */
export const formatCurrency = (amount: number): string => {
  return amount.toFixed(2) + ' kr';
}; 